(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.VisibilityDependence = Lfl.VisibilityDependence || {};

    (function (VisibilityDependence, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.VisibilityDependence, 'ElementVdoiCoordinator')) {
            return;
        }

        /*
         |===============================================================================================================
         | Class definition
         |===============================================================================================================
         */

        /**
         * Sets up and coordinates when elements' visibility depends on input.
         *
         * E.g., when a panel is to be hidden/shown depending on whether some checkbox is checked.
         *
         * @param {object} parameters
         * @param {Lfl.VisibilityDependence.VdoiControllingInputResolver} parameters.controllingInput The resolved
         * controlling input details.
         * @param {string} parameters.dependentElementPath The path to the element which should be hidden when the value
         * (or any of the values) is not selected.
         * @param {boolean} [parameters.autoActivate=false] Whether the mechanisms should be activated immediately, or wait
         * until the client code activates them manually. This mechanism is primarily intended an API for PHP builders
         * which can use a variable to either immediately print and run the mechanisms, or allow the client JS to build
         * the object further.
         * @param {String} [parameters.selectedClass] A class to be applied to the controlled elements if the desired
         * input value is selected.
         * @param {String} [parameters.notSelectedClass] A class to be applied to the controlled elements if the desired
         * input value is not selected.
         *
         * Note: Coordinator name suffix is based on a discussing about naming (link: Vdoi::CoordinatorNaming):
         *          https://stackoverflow.com/questions/1866794/naming-classes-how-to-avoid-calling-everything-a-whatevermanager
         * @memberOf Lfl.VisibilityDependence
         * @lends Lfl.VisibilityDependence.ElementVdoiCoordinator
         * @constructor
         */
        Lfl.VisibilityDependence.ElementVdoiCoordinator = function (parameters) {
            // TODO Later - Vdoi::RemoveOldHiw - rename those classes
            var BASE_CLASS = "visibility-depending-on-radio";
            var INVERTED_CLASS = "visibility-depending-on-radio-inverted";
            var SELECTED_CLASS = "radio-selected";
            var NOT_SELECTED_CLASS = "radio-not-selected";

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Construction
             |-----------------------------------------------------------------------------------------------------------
             */
            var evc = this;

            /**
             * @type {Lfl.VisibilityDependence.VdoiControllingInputResolver}
             */
            var controllingInput;
            /**
             * Element or elements.
             * @type {*|jQuery|HTMLElement}
             */
            var $dependentElement;

            var selectedClass;
            var notSelectedClass;

            function init() {
                // Autoactivation
                if (parameters.autoActivate === true) {
                    evc.activate();
                }

                // Note: most variables are initialized only after activation.
            }

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * Activates the visibility dependence.
             */
            this.activate = function () {
                /*
                |-------------------------------------------------------------------------
                | Init variables */
                controllingInput = parameters.controllingInput;
                $dependentElement = $(parameters.dependentElementPath);

                selectedClass = parameters.selectedClass;
                if (typeof selectedClass === 'undefined') {
                    selectedClass = SELECTED_CLASS;
                }

                notSelectedClass = parameters.notSelectedClass;
                if (typeof notSelectedClass === 'undefined') {
                    notSelectedClass = NOT_SELECTED_CLASS;
                }

                /*
                 |-------------------------------------------------------------------------
                 | Set current state */
                if ($dependentElement.hasClass(BASE_CLASS) !== true &&
                    $dependentElement.hasClass(INVERTED_CLASS) !== true) {
                    $dependentElement.addClass(BASE_CLASS);
                }

                /*
                 |-------------------------------------------------------------------------
                 | Register input changes handling */
                var dispatcher = new Lfl.VisibilityDependence.VdoiEventDispatcher({
                    controllingInput: controllingInput
                });

                dispatcher.onShowing(handleElementShowing);
                dispatcher.onHiding(handleElementHiding);
            };

            // Note: Builder methods for JS client code are expected to be added later.

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

            function handleElementShowing() {
                $dependentElement.addClass(selectedClass);
                $dependentElement.removeClass(notSelectedClass);
                unobscurePlaceholdersOfSelect2($dependentElement);
            }

            function handleElementHiding() {
                $dependentElement.addClass(notSelectedClass);
                $dependentElement.removeClass(selectedClass);
            }

            /*
            |-------------------------------------------------------------------------
            | Select visibility related */
            /**
             * Makes sure all Select2 placeholders are visible inside the element.
             *
             * TODO MOBA II - UnobscurePlaceholdersOfSelect2::II - Refactor to own object, in case Select2 was on a tab, etc.
             *
             * @param $element A jQuery object containing the element.
             */
            function unobscurePlaceholdersOfSelect2($element) {
                $element.find('select').each(function (i, select) {
                    var $select = $(select);

                    // Make sure that the select has Select2. From the official Select2 docs:
                    // https://select2.org/programmatic-control/methods#checking-if-the-plugin-is-initialized
                    if ($select.hasClass("select2-hidden-accessible")) {
                        var currentData = $select.val();
                        // We re-set the values, which will trigger the resizeSearch method.
                        $select.val(currentData).trigger('change');
                    }
                });
            }

            /*
             |-------------------------------------------------------------------------------------------------------
             | First initialization
             |-------------------------------------------------------------------------------------------------------
             */
            // Note - could be replaced by init.call(this). Link: Js::InitFunction
            init();
        };

        /**
         * A static shortcut to set-up the VDOI mechanism.
         *
         * Note: Copied documentation from Lfl.VisibilityDependence.VdoiControllingInputResolver.
         * @param {object} parameters
         * @param {string} parameters.dependentElementPath The path to the element which should be hidden when the value
         * (or any of the values) is not selected.
         * @param {String} [parameters.selectedClass] A class to be applied to the controlled elements if the desired
         * input value is selected.
         * @param {String} [parameters.notSelectedClass] A class to be applied to the controlled elements if the desired
         * input value is not selected.
         *
         * Note: Copied documentation from Lfl.VisibilityDependence.VdoiControllingInputResolver.
         * @param {object} parameters.input Parameters for the `Lfl.VisibilityDependence.VdoiControllingInputResolver`.
         * @param {string} [parameters.input.path] Path to the element of the controlling input. Either path or name
         * must be provided.
         * @param {string} [parameters.input.name] Name of the controlling input. Either path or name must be provided.
         * @param {string | Array | bool} [parameters.desiredValue] The value or an array of values of which at least
         * one has to be selected for the controlled element to be visible. Defaults to 'true' for checkboxes, must be
         * provided for other input types.
         * @param {string} [parameters.input.type] The controlling input's type, can be 'radio', 'select' or 'checkbox'.
         * If not provided, then the type will be resolved automatically based on the input. Later - Vdoi::RemoveOldHiw
         * - this parameter should be possible to later be removed.
         * @param {string|boolean} parameters.input.desiredValue The value to be set for the controlled input to be
         * visible.
         *
         * Note: Extra parameters originally present in the `hideInputWhenRadioNotSelected` function.
         * @param {boolean} [parameters.focusTheControllingInputFirstTime] If input should be focused first time it is
         * selected. Usually for the element with first focus on page, similar to tabIndex=1.
         * See: VisibilityDependsOnInput::FocusInputFirstTime
         * @param {boolean} [parameters.overrideAutofocus] If autofocus should be removed from other elements, so that
         * they do not 'steal' this element's focus. Used in tandem with focusTheControllingInputFirstTime.
         */
        Lfl.VisibilityDependence.ElementVdoiCoordinator.createAndActivate = function (parameters) {
            /*
            |-------------------------------------------------------------------------
            | Element hiding */
            var controllingInput = new Lfl.VisibilityDependence.VdoiControllingInputResolver({
                path: parameters.input.path,
                name: parameters.input.name,
                desiredValue: parameters.input.desiredValue,
                type: parameters.input.type
            });

            var evdoi = new Lfl.VisibilityDependence.ElementVdoiCoordinator({
                controllingInput: controllingInput,
                dependentElementPath: parameters.dependentElementPath,
                selectedClass: parameters.selectedClass,
                notSelectedClass: parameters.notSelectedClass
            });
            evdoi.activate();

            /*
            |-------------------------------------------------------------------------
            | Focus */
            if (typeof parameters.focusTheControllingInputFirstTime === 'undefined') {
                parameters.focusTheControllingInputFirstTime = false;
            }
            if (typeof parameters.overrideAutofocus === 'undefined') {
                parameters.overrideAutofocus = false;
            }
            if (parameters.focusTheControllingInputFirstTime) {
                new Lfl.Forms.InputFocuser().focus(controllingInput.getControllingInput(), parameters.overrideAutofocus);
            }

            /*
            |-------------------------------------------------------------------------
            | Return */
            return evdoi;
        }
    }(Lfl.VisibilityDependence, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
